import React, { SVGProps } from 'react';

const CollectionMinusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none" {...props}>
      <g clipPath="url(#clip0_6790_17664)">
        <path
          d="M15.9332 12.3535H1.10605V25.5332H15.9332M15.9332 12.3535V25.5332M15.9332 12.3535V2.46875H6.04843V12.3535H15.9332ZM15.9332 25.5332H27.4654V15.6484H15.9332M15.9332 25.5332V15.6484M15.9332 15.6484H25.818V5.76367H15.9332V15.6484ZM9.34335 5.76367H12.6383M6.04843 15.6484H10.9908M19.2281 9.05859H22.523M19.8707 18.9434H23.5279"
          stroke="black"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.28574 24C11.0472 24 13.2857 21.7614 13.2857 19C13.2857 16.2386 11.0472 14 8.28574 14C5.52431 14 3.28574 16.2386 3.28574 19C3.28574 21.7614 5.52431 24 8.28574 24Z"
          fill="white"
          stroke="#E51C00"
          strokeMiterlimit="10"
        />
        <path d="M10.7547 18.9985H5.81683" stroke="#E51C00" strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_6790_17664">
          <rect width="28" height="28" fill="white" transform="translate(0.285736)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CollectionMinusIcon;
